let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a8238")).then(() => parcelRequire('d8ZiM'));